var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8.68188C2.72386 8.68188 2.5 8.45803 2.5 8.18188L2.5 2.06868L1.11215 3.52663C0.921756 3.72664 0.60527 3.73443 0.405259 3.54404C0.205248 3.35364 0.197453 3.03716 0.387848 2.83714L2.63785 0.473509C2.73222 0.374366 2.86312 0.318249 3 0.318249C3.13688 0.318249 3.26778 0.374366 3.36215 0.473509L5.61215 2.83714C5.80255 3.03716 5.79475 3.35364 5.59474 3.54404C5.39473 3.73443 5.07824 3.72664 4.88785 3.52663L3.5 2.06868L3.5 8.18188C3.5 8.45803 3.27614 8.68188 3 8.68188Z",
    fill: "#0C542E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrUp);
export default __webpack_public_path__ + "static/media/arrUp.491d4d136e214ebc7222547d4d18eeb2.svg";
export { ForwardRef as ReactComponent };